import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const PurchaseTrackingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M26.25 9.31872C26.25 8.56935 25.4562 8.08623 24.7906 8.43049L14 14.0115V28.2037L24.477 22.7849C25.5651 22.2221 26.25 21.0884 26.25 19.8502V9.31872Z"
          fill="#C0AAFE"
        />
        <path
          d="M1.75 9.31872C1.75 8.56935 2.54379 8.08623 3.2094 8.43049L14 14.0115V28.4571L3.52297 23.0383C2.43491 22.4756 1.75 21.3419 1.75 20.1036V9.31872Z"
          fill="white"
        />
        <path
          d="M12.523 2.10502C12.9869 1.86508 13.4934 1.74512 14 1.74512C14.5066 1.74512 15.0131 1.86508 15.477 2.10502L24.5327 6.78866C25.2535 7.16147 25.2535 8.19232 24.5327 8.56512L14 14.0127L3.46736 8.56512C2.74656 8.19232 2.74656 7.16147 3.46736 6.78866L12.523 2.10502Z"
          fill="#E4E0FF"
        />
        <path
          d="M7.18817 9.48353L18.3757 3.69727L21.6762 5.40434L9.36987 11.7693V17.2507L6.36987 15.699V10.838C6.36987 10.2665 6.68598 9.74327 7.18817 9.48353Z"
          fill="#006DFF"
        />
        <path
          d="M4.53697 20.2991C4.23032 20.1406 3.85326 20.2607 3.69478 20.5674C3.5363 20.874 3.6564 21.2511 3.96305 21.4096L5.92305 22.4226C6.22969 22.581 6.60675 22.4609 6.76524 22.1543C6.92372 21.8476 6.80361 21.4706 6.49697 21.3121L4.53697 20.2991Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8376 1.44611C14.685 0.849996 13.315 0.849996 12.1624 1.44611L3.1624 6.10098C1.83414 6.78797 1 8.1585 1 9.6539V20.3462C1 21.8416 1.83414 23.2121 3.1624 23.8991L12.1624 28.554C13.315 29.1501 14.685 29.1501 15.8376 28.554L24.8376 23.8991C26.1659 23.2121 27 21.8416 27 20.3462V9.6539C27 8.1585 26.1659 6.78797 24.8376 6.10098L15.8376 1.44611ZM12.8515 2.77845C13.5718 2.40588 14.4282 2.40588 15.1485 2.77845L24.1485 7.43333L24.1554 7.43693C24.3493 7.53722 24.3493 7.81456 24.1554 7.91484L15.1485 12.5733C14.4281 12.9459 13.5718 12.9459 12.8515 12.5733L3.84452 7.91484C3.65062 7.81456 3.65062 7.53725 3.84452 7.43696L3.8515 7.43333L12.8515 2.77845ZM2.63491 8.84356C2.54688 9.10038 2.5 9.37363 2.5 9.6539V20.3462C2.5 21.2808 3.02134 22.1374 3.8515 22.5668L12.8515 27.2217C12.9805 27.2884 13.1138 27.3432 13.25 27.386V14.2818C12.8757 14.2104 12.5092 14.085 12.1624 13.9057L3.15542 9.24719C2.94826 9.14004 2.77476 9.00217 2.63491 8.84356ZM15.1485 27.2217C15.0195 27.2884 14.8862 27.3432 14.75 27.386V14.2818C15.1243 14.2104 15.4908 14.085 15.8376 13.9057L24.8445 9.24719C25.0517 9.14004 25.2252 9.00214 25.3651 8.84351C25.4531 9.10035 25.5 9.37362 25.5 9.6539V20.3462C25.5 21.2808 24.9787 22.1374 24.1485 22.5668L15.1485 27.2217Z"
          fill="#0F3893"
        />
        <path
          d="M31 23.5C31 27.6421 27.6421 31 23.5 31C19.3579 31 16 27.6421 16 23.5C16 19.3579 19.3579 16 23.5 16C27.6421 16 31 19.3579 31 23.5Z"
          fill="#006DFF"
        />
        <path
          d="M24.9419 20.5581C24.6979 20.314 24.3021 20.314 24.0581 20.5581C23.814 20.8021 23.814 21.1979 24.0581 21.4419L25.4911 22.875L20 22.875C19.6548 22.875 19.375 23.1548 19.375 23.5C19.375 23.8452 19.6548 24.125 20 24.125L25.4911 24.125L24.0581 25.5581C23.814 25.8021 23.814 26.1979 24.0581 26.4419C24.3021 26.686 24.6979 26.686 24.9419 26.4419L27.4399 23.9439C27.4468 23.9371 27.4535 23.9302 27.4601 23.9231C27.5625 23.8117 27.625 23.6632 27.625 23.5C27.625 23.4166 27.6087 23.337 27.579 23.2643C27.5485 23.1892 27.5028 23.1189 27.4419 23.058L24.9419 20.5581Z"
          fill="white"
        />
      </svg>
    );
  }
);

export default PurchaseTrackingIcon;
